<template>
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">{{ _('Address') }}</h4>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label for="company">{{ _('Company') }}</label>
            <input type="text" class="form-control" v-model="address.company" :placeholder="_('Company')" />
          </div>
          <div class="form-group">
            <label for="department">{{ _('Department') }}</label>
            <input type="text" class="form-control" v-model="address.department" :placeholder="_('Department')" />
          </div>
          <div class="form-group">
            <label for="ident">{{ _('Business ID') }}</label>
            <input type="text" class="form-control" v-model="address.ident" :placeholder="_('Business ID')" />
          </div>
          <div class="form-group">
            <label for="address">{{ _('Street address') }}</label>
            <input type="text" class="form-control" v-model="address.address" :placeholder="_('Street address')" />
          </div>
          <div class="form-group">
            <label for="zip">{{ _('Postal code') }}</label>
            <input type="text" class="form-control" v-model="address.zip" :placeholder="_('Postal code')" />
          </div>
          <div class="form-group">
            <label for="city">{{ _('City') }}</label>
            <input type="text" class="form-control" v-model="address.city" :placeholder="_('City')" />
          </div>
          <div class="form-group">
            <label for="country">{{ _('Country') }}</label>
            <select class="form-control" v-model="address.country">
              <option v-for="(country, id) in countries" :value="id" v-if="id == 'FI'">{{ country }}</option>
              <option v-for="(country, id) in countries" :value="id" v-if="isPriorityCountry(id)">{{ country }}</option>
              <option class="select-separator" disabled="disabled">────────────</option>
              <option v-for="(country, id) in countries" :value="id">{{ country }}</option>
            </select>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label for="phone">{{ _('Phone') }}</label>
            <input type="text" class="form-control" v-model="address.phone" :placeholder="_('Phone')" />
          </div>
          <div class="form-group">
            <label for="name">{{ _('Name') }}</label>
            <input type="text" class="form-control" v-model="address.name" :placeholder="_('Name')" />
          </div>
          <div class="form-group">
            <label for="evoice">{{ _('E-Invoice Address') }}</label>
            <input type="text" class="form-control" v-model="address.evoice" :placeholder="_('E-Invoice Address')" />
          </div>
          <div class="form-group">
            <label for="evoiceint">{{ _('E-Invoice Intermediary') }}</label>
            <input type="text" class="form-control" v-model="address.evoiceint" :placeholder="_('E-Invoice Intermediary')" />
          </div>
          <div class="form-group">
            <label for="email">{{ _('Email') }}</label>
            <input type="text" class="form-control" v-model="address.email" :placeholder="_('Email')" />
          </div>
          <div class="form-group">
            <label for="billingemail">{{ _('Billing email') }}</label>
            <input type="text" class="form-control" v-model="address.billingemail" :placeholder="_('Billing email')" />
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-default hidden-xs" v-on:click="close"><i class="fa fa-close fa-fw"></i> {{ _('Close') }}</button>
      <button type="button" class="btn btn-success" v-on:click="save" :disabled="!isValid"><i class="fa fa-check fa-fw"></i>{{ _('Ok') }}</button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      address: {}
    }
  },
  props: ['value'],
  computed: {
    ...mapGetters(['countries']),
    isValid () {
      return this.address && this.address.company && this.address.address && this.address.zip && this.address.city && this.address.country
    }
  },
  methods: {
    isPriorityCountry (id) {
      return ['SE', 'NO', 'DK', 'EE', 'RU'].indexOf(id) !== -1
    },
    close () {
      this.$emit('close')
    },
    save () {
      this.$emit('save', this.address)
    }
  },
  created() {
    if (this.value) {
      this.address = Object.assign({}, this.value)
    }
  }
}

</script>